import React from "react";

import ImagePicker from "./image-picker";
import ModalButton from "../../attributes/compare-table/modal-button";
import ImagePickerDisplay from "./display";

const ImagePickerModal = ({ provider, dataType, defaultValue, updateOnChange, disabled, name, attribute }) => {
    return (
        <div>
            <ModalButton
                text="Image Picker"
                disabled={disabled}
            >
                <ImagePicker
                    label={attribute.name}
                    uuid={name}
                    name={`ImagePicker_${name}`}
                    provider={provider}
                    defaultValue={defaultValue}
                    updateOnChange={updateOnChange}
                />
            </ModalButton>
            <ImagePickerDisplay
                type={dataType}
                value={defaultValue}
                provider={provider}
            />
        </div>
    );
};

export default ImagePickerModal;
